(function (e, s, sArr) {
const d = document;
d.addEventListener(e, function () {
    function logic(text, skipGrammar = true) {
        const variants = {
            C: ['typography-variant-1'],
            E: ['typography-variant-1', 'typography-variant-2'],
            O: ['typography-variant-2', 'typography-variant-2'],
            R: ['typography-variant-1', 'typography-variant-1'],
            N: ['typography-variant-1', 'typography-variant-1'],
            A: ['typography-variant-1', 'typography-variant-1'],
            M: ['typography-variant-1', 'typography-variant-1'],
            X: ['typography-variant-1'],
            W: ['typography-variant-1', 'typography-variant-1'],
            S: ['typography-variant-1'],
        };
        
        const variantsChangeFirstLetter = {
            W: ['typography-variant-1']
        }
        
        const lettersChanged = {};
        
        // List of grammatical words to skip
        const grammaticalWords = new Set(["in", "is", "or", "the", "of", "to", "a", "what", "what's"]);
        
        // List of skipped words
        const excludedWords = new Set(["fum", "we", "FÜM", "&"]);
        
        // Do not change first letter except when the letter is "?"
        const changeFirstLetterIfLetterIs = new Set([]); // consider as priority word

        // Change first letter if words
        const changeFirstLetterWord = new Set(["with"]);

        // Change second letter if words are
        const changeSecondLetterWord = new Set(["and"]);
        
        return text.replace(/(<[^>]+>)|(\b\w+\b)/g, (match, htmlTag, word) => {
            if (htmlTag) {
                // Return the HTML tag as-is
                return htmlTag;
            }
        
            if (
                word.length < 2 && !changeFirstLetterIfLetterIs.has(word[0].toLowerCase()) || 
                grammaticalWords.has(word.toLowerCase()) && !changeFirstLetterIfLetterIs.has(word[0].toLowerCase()) ||
                word.length < 2 && !changeSecondLetterIfLetterIs.has(word[0].toLowerCase()) || 
                grammaticalWords.has(word.toLowerCase()) && !changeSecondLetterIfLetterIs.has(word[0].toLowerCase())
            ) return word; // Skip short words
            if (excludedWords.has(word.toLowerCase())) return word;

            
            let transformedWord = word;
            let appliedCount = 0;
            const variantMap = {};
            const variantChangeFirstLetterMap = {};

            // Change first letter of word
            if (changeFirstLetterWord.has(word.toLowerCase())) {
                const letter = word[0].toUpperCase();
                const variant = variants[letter];
                if (variant && !lettersChanged[letter]) {
                    variantMap[0] = variant[0];
                    transformedWord = `<span class="${variantMap[0]}">${transformedWord[0]}</span>${transformedWord.slice(1)}`;
                    appliedCount++;
                    lettersChanged[letter] = true;
                }
            }

            // Change second letter of word (if word match from set)
            if (word.length > 1 && changeSecondLetterWord.has(word.toLowerCase())) {
                
                const letter = word[1].toUpperCase();
                const variant = variants[letter];

                if (variant && !lettersChanged[letter]) {
                    // Transform the second letter if a variant exists and it hasn't been changed yet
                    variantMap[1] = variant[1];
                    transformedWord = `${transformedWord.slice(0,1)}<span class="${variantMap[1]}">${transformedWord[1]}</span>${transformedWord.slice(2)}`;
                    appliedCount++;
                    lettersChanged[letter] = true;
                }
            }

            
            // Check if the first letter is "W" and apply its variant first
            if (changeFirstLetterIfLetterIs.has(word[0].toLowerCase())) {
                const letter = word[0].toUpperCase();
                const variant = variants[letter];
                if (variant && !lettersChanged[letter]) {
                    variantMap[0] = variant[0];
                    transformedWord = `<span class="${variantMap[0]}">${transformedWord[0]}</span>${transformedWord.slice(1)}`;
                    appliedCount++;
                    lettersChanged[letter] = true;
                }
            }
        
            // Dynamic Variant
            for (let [letter, variant] of Object.entries(variants)) {
                if (lettersChanged[letter]) continue;
        
                let count = 0;
                let positions = [];
              
                for (let i = 0; i < word.length; i++) {
                    if (word[i].toUpperCase() === letter && (i !== 0 || appliedCount > 0)) {
                        count++;
        
                        if (
                            appliedCount === 1 && !changeFirstLetterIfLetterIs.has(word[0].toLowerCase()) || 
                            (count === 1 && i === 0) && !changeFirstLetterIfLetterIs.has(word[0].toLowerCase())
                        ) continue; // Skip first letter or first occurrence
                        if (count === variant.length || (word.length >= 8 && count === 3 && appliedCount === 2)) break;
        
                        // Don't change adjacent letters and apply variant only once or twice based on word length
                        if (!variantMap[i - 1] && ((word.length >= 8 && appliedCount < 2) || (word.length < 8 && appliedCount < 1))) {
                            positions.push(i);
                            variantMap[i] = variant[count - 1];
                            appliedCount++;
                            lettersChanged[letter] = true; // Mark this letter as changed
        
                            // Break if we've applied the maximum allowed variants
                            if ((word.length >= 8 && appliedCount === 2) || (word.length < 8 && appliedCount === 1)) {
                                continue;
                            }
                        }
                    }
                }
        
                if (positions.length > 0) {
                    transformedWord = positions.reduce((acc, pos) => {
                        return acc.slice(0, pos) + `<span class="${variantMap[pos]}">${acc[pos]}</span>` + acc.slice(pos + 1);
                    }, transformedWord);
                }
            }
        
            // Words with no glyph changes.
            for (let [letter, variant] of Object.entries(variantsChangeFirstLetter)) {
                if (lettersChanged[letter]) continue;
        
                let count = 0;
                let positions = [];
        
                if (appliedCount === 0) {
                    count++;
                    for (let i = 0; i < word.length; i++) {
                        if (word[i].toUpperCase() === letter) {
                            positions.push(i);
                            variantChangeFirstLetterMap[i] = variant[count - 1];
                            appliedCount++;
                            lettersChanged[letter] = true; // Mark this letter as changed
                        }
                    }
        
                    if (positions.length > 0) {
                        transformedWord = positions.reduce((acc, pos) => {
                            return acc.slice(0, pos) + `<span class="${variantChangeFirstLetterMap[pos]}">${acc[pos]}</span>` + acc.slice(pos + 1);
                        }, transformedWord);
                    }
                }
            }
        
            return transformedWord;
        });
    }    

    function htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    }


    function proc(elements) {
        elements.forEach(element => {
            // const containsTheFollowingChars = ["&"];
            // let innerHTML = element.innerHTML;

            // // if containsTheFollowingChars use element.innerText

            // innerHTML = logic(innerHTML);

            // // element.innerHTML = innerHTML;
            // element.innerHTML = innerHTML.replace(/&amp;/g, "&");

            const containsTheFollowingChars = ["&"];
            let innerHTML = element.innerHTML;
        
            // Check if innerHTML contains any character from containsTheFollowingChars
            if (containsTheFollowingChars.some(char => innerHTML.includes(char))) {
                innerHTML = element.innerText;
            }
        
            innerHTML = logic(innerHTML);
        
            // Replace &amp; with &
            element.innerHTML = innerHTML.replace(/&amp;/g, "&");

        });
    }

    let elSelectors = s;
    

    if (sArr != null) {
      sArr.forEach((item, idx) => {
        elSelectors = elSelectors + ", " + item;
      })
    }

    console.log("EL Selectors", elSelectors);

    proc(d.querySelectorAll(elSelectors));
});
})(
  'DOMContentLoaded', 
  '.typography-dynamic',
  [
    '.fum-article-content > h1',
    '.fum-article-content > h2'
  ]
);